export const servicios = [

    
    {
        "descripcion": "Invierte en Ti, Invierte en Hidalgo 2026",
        "urlRuts": "/Resultados/invierte"
    },
    {
        "descripcion": "Transformando Emprendedores 2026",
        "urlRuts": "/Resultados/Emprendedores"
    },
    {
        "descripcion": "Bienestar de Personas Cuidadoras de Personas con Discapacidad 2026",
        "urlRuts": "/Resultados/Cuidadoras"
    },
    {
        "descripcion": "18.° Concurso de Bordados Región Otomí-Tepehua 2026",
        "urlRuts": "/Resultados/Otepehua"
    },
    {
        "descripcion": "9.° Concurso de Artesanías del Valle del Mezquital 2026",
        "urlRuts": "/Resultados/Vmezquital"
    },
    {
        "descripcion": "13.° Concurso de Artesanías de la Huasteca Hidalguense 2026",
        "urlRuts": "/Resultados/HHidalguense"
    },
    {
        "descripcion": "Programa Fomento a la Capacitación de las Personas Artesanas 2026",
        "urlRuts": "/Resultados/FCartesanos"
    },
    {
        "descripcion": "Programa Desarrollo Inclusivo 2026",
        "urlRuts": "/Resultados/Inclusion"
    },
    {
        "descripcion": "Programa Bienestar para Personas Artesanas 2026",
        "urlRuts": "/Resultados/BienestarArtesanos"
    },
    {
        "descripcion": "Programa de Apoyo a Migrantes 2026",
        "urlRuts": "/Resultados/Migrantes"
    },
     {
        "descripcion": "Programa Madres Trabajadoras 1ª etapa",
        "urlRuts": "https://bienestar-apoyos.hidalgo.gob.mx/2026-0001/resultados-mt/" 
    },
    {
        "descripcion": "Programa Bienestar y Desarrollo 1ª etapa",
        "urlRuts": "https://bienestar-apoyos.hidalgo.gob.mx/2026-0001/resultados-byd/" 
    },
   
] 